import React, { Component } from 'react'

class MessageGroupUser extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        const { customer, company, groupUserId, selectedCompaniesNames } = this.props

        return (
            <div>
                <span><b>{customer.surname ? customer.name + " " + customer.surname : customer.phone}</b>, {company ? company.name : 'Tillhör inget företag'} - Är logistikare åt företag: <b>{selectedCompaniesNames && selectedCompaniesNames.length ? `${selectedCompaniesNames.join(', ')}` : 'Alla'}</b></span> &nbsp;&nbsp;&nbsp;
                <span onClick={() => this.props.removeUserAccesses([groupUserId])} style={{ color: '#bb1010', cursor: 'pointer' }}>Ta bort</span>
            </div>
        )
    }
}

export default MessageGroupUser